var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft02Icon } from 'hugeicons-react';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { useExportChatMutation } from '../../../../application/features/chat-download/chat-download-api';
import { useGetConversationsQuery, useLazyGetConversationQuery } from '../../../../application/features/chat/chat-api';
import { useLazyGetMachineDocumentListByIdsQuery } from '../../../../application/features/machine-documents/machine-document-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import usePersistCompany from '../../../hooks/usePersistCompany';
import ChatPDF from '../../chats/chat-section/chat-header/ChatPDF';
import AuditFeedback from './audit-feedback';
var AuditChatDetails = function () {
    var _a, _b, _c;
    var theme = useTheme();
    var _d = useParams(), conversationId = _d.conversationId, userId = _d.userId;
    var navigate = useNavigate();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var contentRef = useRef(null);
    usePersistCompany();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var _e = __read(useState(false), 2), downloadChatOpen = _e[0], setDownloadChatOpen = _e[1];
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var _f = __read(useLazyGetConversationQuery(), 2), getConversation = _f[0], _g = _f[1], conversation = _g.data, conversationLoading = _g.isLoading;
    var _h = __read(useExportChatMutation(), 2), downloadChat = _h[0], downloadChatLoading = _h[1].isLoading;
    var _j = useGetConversationsQuery(currentUser.userId).data, conversations = _j === void 0 ? [] : _j;
    var _k = __read(useLazyGetMachineDocumentListByIdsQuery(), 2), getDocumentDetails = _k[0], _l = _k[1], _m = _l.data, documentDetails = _m === void 0 ? [] : _m, documentDetailsLoading = _l.isLoading;
    var currentConversation = (_a = conversations.find(function (conversation) { return conversation.conversation_id === conversationId; })) === null || _a === void 0 ? void 0 : _a.conversation_name;
    var downloadChatDisabled = (conversation === null || conversation === void 0 ? void 0 : conversation.messages.length) === 0 || conversationLoading || downloadChatLoading;
    useEffect(function () {
        if (conversation === null || conversation === void 0 ? void 0 : conversation.document_list.length) {
            var documentIds = conversation.document_list.map(function (document) { return document.document_id; });
            getDocumentDetails({ machineDocumentIds: documentIds });
        }
    }, [conversation, getDocumentDetails]);
    useEffect(function () {
        if (conversationId && userId) {
            var conversationArg = { conversationId: conversationId, userId: userId };
            getConversation(conversationArg);
        }
    }, [conversationId, userId, getConversation]);
    var handleBackClick = function () { return navigate(-1); };
    var downloadChatPdf = function () {
        setDownloadChatOpen(true);
        setTimeout(function () {
            exportChatPdf();
        }, 300);
    };
    var exportChatPdf = useReactToPrint({
        contentRef: contentRef,
        ignoreGlobalStyles: true,
        pageStyle: "@media print {\n                      @page {\n                          size: legal portrait;\n                           @bottom-right {\n                              content: \"Page \" counter(page) \" of \" counter(pages);\n                              font-size: 10px;\n                            }\n                        }\n                    }",
        print: function (printIframe) { return __awaiter(void 0, void 0, void 0, function () {
            var document, html;
            return __generator(this, function (_a) {
                setDownloadChatOpen(false);
                document = printIframe.contentDocument;
                if (document) {
                    html = document.getElementsByTagName('html');
                    downloadChat({ htmlContent: html[0].innerHTML });
                }
                return [2 /*return*/];
            });
        }); }
    });
    return (_jsxs(Box, { sx: {
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [!isscreen600900Landscape && (_jsxs(Box, { padding: isXs ? undefined : isSm ? 1 : 1, display: 'flex', flexDirection: 'row', alignItems: 'center', children: [_jsx(IconButton, { color: 'primary', onClick: handleBackClick, children: _jsx(ArrowLeft02Icon, { size: 24 }) }), _jsx(Typography, { variant: 'h3', color: '#009983', children: translate('audit.chatDetails') })] })), !conversationLoading && (_jsx(AuditFeedback, { documents: conversation === null || conversation === void 0 ? void 0 : conversation.document_list, messages: conversation === null || conversation === void 0 ? void 0 : conversation.messages, handleDownloadClick: downloadChatPdf, downloadChatDisabled: downloadChatDisabled, documentDetails: documentDetails, documentDetailsLoading: documentDetailsLoading })), downloadChatOpen && (_jsx("div", { style: { display: 'none' }, children: _jsx("div", { ref: contentRef, children: _jsx(ChatPDF, { documents: documentDetails, messages: conversation === null || conversation === void 0 ? void 0 : conversation.messages, conversationName: currentConversation, userName: currentUser.name, machineName: (_c = (_b = documentDetails[0]) === null || _b === void 0 ? void 0 : _b.machineName) !== null && _c !== void 0 ? _c : '' }) }) }))] }));
};
export default AuditChatDetails;
